import { CheckCircle, Close } from '@mui/icons-material';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material'
import { Dispatch, SetStateAction, useCallback, useEffect} from 'react'
import { useDropzone } from 'react-dropzone';
import { useAppDispatch, useAppSelector } from '../../../../../Redux/store';
import { setNextDisabled } from '../../Slices/TalentProfileCreationSlice';

interface IResumeUploadProps {
    uploadedResume: File | undefined;
    setUploadedResume: Dispatch<SetStateAction<File | undefined>>;
}

export const ResumeUpload = ({uploadedResume, setUploadedResume}: IResumeUploadProps) => {
/* ******************** Hooks ******************** */ 
const dispatch = useAppDispatch();
const nextDisabled = useAppSelector( state => state.TalentProfileCreation.nextDisabled);
const onDrop = useCallback((acceptedFiles: any ) => {
        setUploadedResume(acceptedFiles[0]);
        // console.log(acceptedFiles)
    }, [])
const {getRootProps, getInputProps, isDragActive, open} = useDropzone({onDrop, accept: {
    'application/msword': ['.doc'], 
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'], 
    'application/pdf': ['.pdf'],
}, maxFiles: 1});
/* ******************** Variables ******************** */
/* ******************** Functions ******************** */
const handleDelete = () => {
    setUploadedResume(undefined);
}
/* ******************** Effects ******************** */
useEffect(() =>{
    if (uploadedResume && nextDisabled) {
        dispatch(setNextDisabled(false));
    }
    if (!uploadedResume && !nextDisabled) {
        dispatch(setNextDisabled(true));
    }
}, [uploadedResume])
/* ******************** JSX ******************** */
    return (
        <Grid container>
            <Typography variant={'lora-title-large'} fontWeight={"bold"} color={'primary'}>Upload your resume</Typography>  
            <Typography variant={'body-medium'} color={'black.400'} paddingY={'8px'}>When you upload your resume, we parse information to help you populate your profile. Don’t worry, you’ll have a chance to change the information.</Typography>
            <Box display={"flex"} justifyContent={"center"} flexDirection={"row"} width={"100%"} paddingY={'12px'}>
                <Box display={"flex"} flexDirection={"column"} {...getRootProps()} rowGap={'8px'}>
                    <input {...getInputProps()} />
                    {
                        uploadedResume && 
                        <Box display={'flex'} flexDirection={'row'} gap={1} alignItems={'center'}>
                            
                            <CheckCircle />
                            <Typography>{uploadedResume.name}</Typography>
                            <IconButton onClick={handleDelete}><Close /></IconButton>
                        </Box>
                    }                    
                    <Box display={'flex'} flexDirection={'row'} justifyContent={'center'}>
                        <Button variant={'outlined'} size={'large'}>Upload resume</Button>
                    </Box>
                </Box>
            </Box>
        </Grid>
    )
}